import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { formatPriceInProduct } from '../../helpers/orderProductModal';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate } from 'src/utils/helpers';
import Image from 'src/view/components/Image/Image';
import { IResponseComboItem } from '~/types/combo';
import { PRODUCT_TYPE } from '~/types/product';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

interface IProps {
  type: PRODUCT_TYPE;
  item: IResponseComboItem;
  selected?: boolean;
  onSelectItem: (item: IResponseComboItem) => void;
}

export const ComboItem: React.FC<IProps> = memo((props: IProps): JSX.Element => {
  const isMeal: boolean = props.type === PRODUCT_TYPE.MEAL_COMBO;
  const units: string[] = productUtils.getComboItemUnits(props.item);
  const price: string = formatPriceInProduct(productUtils.calculateComboItemPrice(props.item));
  const unavailableMessage: string | undefined = productUtils.getComboItemUnavailableMessage(props.item, isMeal);

  const imageWrapperClassName = useMemo((): string => {
    return classNames('product-combo-item__image', {
      'product-combo-item__image_active': props.item.is_selected || props.selected,
      'opacity-50': unavailableMessage,
    });
  }, [props.item, props.selected]);

  const onSelectItem = () => {
    props.onSelectItem(props.item);
  };

  return (
    <li className="product-combo-item" onClick={onSelectItem}>
      <Image className="full-width full-height" wrapperClassName={imageWrapperClassName} aspectRatio="none" src={props.item.image} />

      {unavailableMessage ? <span className="product-combo-item__unavailable-msg letter-spacing-12">{localeStore.t(unavailableMessage)}</span> : null}

      <div className={classNames('product-combo-item__container', { 'opacity-50': unavailableMessage })}>
        <p className="product-combo-item__name text-lite-elipsis">{getTranslate(props.item.name)}</p>

        <div className={`d-flex flex-row align-items-center justify-content-${isMeal ? 'between' : 'end'} mt-2`}>
          {isMeal ? <p className="product-combo-item__price letter-spacing-12">{price}</p> : null}
          <p className="product-combo-item__units">{units?.map((unit) => (unit ? <span key={unit}>{unit}</span> : null))}</p>
        </div>
      </div>
    </li>
  );
});
